import { useRef } from "react";

const TunerText = (props) => {
  const { note, frequency } = props;

  const noteRef = useRef(null);
  const frequencyRef = useRef(null);

  return (
    <div className="tuner-text">
      <span className="tuner-text-note" ref={noteRef}>
        {note}
      </span>
      <span className="tuner-text-frequency" ref={frequencyRef}>
        {frequency}
      </span>
    </div>
  );
};

export default TunerText;
